import React from "react";
import { ArrowRight } from "lucide-react";
import "./AnnouncementBar.css";

function AnnouncementBar() {
  return (
    <div className="announcement-bar" role="region" aria-label="Funding round">
      <span className="announcement-text">
        <span className="announcement-long">
          We're raising a <strong>$1M seed round</strong> to scale DLSurf,
          FitHisaab and Automyc.
        </span>
        <span className="announcement-short">
          Raising a <strong>$1M seed round</strong>
        </span>
      </span>

      <a
        className="announcement-link"
        href="https://calendly.com/arjun-zcax/dlplatforms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Investor enquiries <ArrowRight size={14} />
      </a>
    </div>
  );
}

export default AnnouncementBar;
